<template>
  <div>
    <v-layout row wrap>
      <v-flex d-flex xs12>
        <v-text-field
          v-if="selected"
          readonly
          name="name"
          label="Auftrag"
          id="id"
          :value="selected.name"
          @click="search.dialog = true"
        ></v-text-field>
        <v-text-field
          v-else
          readonly
          name="name"
          label="Auftrag"
          id="id"
          value="Auftrag auswählen.."
          @click="search.dialog = true"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-dialog
          v-model="search.dialog"
          fullscreen        >
          <v-card>
            <v-toolbar :height="80" dark color="secondary">
            <v-btn icon dark @click="close()">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>
              Auftrag auswählen..
            </v-toolbar-title>
          </v-toolbar>

            <v-card-title>
              <v-text-field
                name="name"
                label="Auftrag"
                id="id"
                v-model="search.query"
                autocomplete="off"
              ></v-text-field>
            </v-card-title>
            <v-card-text>
              <v-data-iterator
                :items="searchResults"
                row
                wrap
                hide-actions
              >
                <template v-slot:item="props">
                  <v-flex xs12>
                    <v-card class="mb-2" >
                      <v-card-title primary-title class="pt-3 pb-0 clickable" @click="selectSalesOrder(props.item)">
                        <v-layout row>
                          <v-flex pa-1 grow>
                            <div class="subheading">
                              {{ props.item.name }}
                            </div>
                            <span class="grey--text">{{ props.item.address ? props.item.address : '-' }}</span>
                          </v-flex>
                        </v-layout>
                      </v-card-title>
                    </v-card>
                  </v-flex>
                </template>
              </v-data-iterator>
            </v-card-text>
          </v-card>
        </v-dialog>
    <v-layout row wrap v-if="selected">
      <v-flex xs12 mb-2>
        <v-select
          :items="cold_warm"
          label="Anzeigen"
          item-text="name"
          item-value="value"
          v-model="cold_warm_selected"
        ></v-select>
      </v-flex>
      <v-flex xs12 mb-2>
        <v-card>
          <v-card-title>
            <h3>{{ $vuetify.t('$vuetify.lobis.customer') }}: {{ selected.customer }}</h3>
          </v-card-title>
          <v-card-text>
            <p v-if="selected.contact_person">{{ $vuetify.t('$vuetify.lobis.contactPerson') }}: {{ selected.contact_person }}</p>
            <p v-if="selected.contact_person_tel">{{ $vuetify.t('$vuetify.lobis.phoneNumber') }} {{ $vuetify.t('$vuetify.lobis.contactPerson') }}: <a :href="'tel:' + selected.contact_person_tel">{{ selected.contact_person_tel }}</a></p>
            <p v-else-if="selected.phone_number">{{ $vuetify.t('$vuetify.lobis.phoneNumber') }}: <a :href="'tel:' + selected.phone_number">{{ selected.phone_number }}</a></p>
            <p v-if="selected.location_description">{{ $vuetify.t('$vuetify.lobis.route') }}:</p>
            {{ selected.location_description }}
            <p>{{ $vuetify.t('$vuetify.lobis.address') }}:</p>
            {{ selected.address }}
            <p v-if="selected.planned_hours_cold">{{ $vuetify.t('$vuetify.lobis.planned_hours_cold') }}: {{ selected.planned_hours_cold }} h</p>
            <p v-if="selected.planned_hours_warm">{{ $vuetify.t('$vuetify.lobis.planned_hours_warm') }}: {{ selected.planned_hours_warm }} h</p>
            <p>{{ selected.note }}</p>
          </v-card-text>
          <v-card-actions>
            <v-btn v-if="mapsLink" :href="mapsLink" target="_blank" color="success">{{ $vuetify.t('$vuetify.lobis.startNavigation') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-layout row wrap>
        <salesLine v-for="(line, index) in selected.lines" :key=index :salesLine=line></salesLine>
        <salesLine :salesLine=additionalSalesline></salesLine>
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { SALESORDER_INDEX, SALESLINES_GET, SALESORDER_SELECT } from '../../store/actions/salesOrder'
import { TIMEENTRY_INDEX } from '../../store/actions/timeEntry'
import { USER_COLDWARM } from '../../store/actions/user'
import salesLine from './SalesLine.vue'

export default {
  components: { salesLine },
  name: 'salesOrder',
  data () {
    return {
      cold_warm: [
        { value: 0, name: 'Alles' },
        { value: -1, name: 'Kalte Böden' },
        { value: 1, name: 'Warme Böden' }
      ],
      search: {
        query: '',
        dialog: false,
        results: []
      }
    }
  },
  computed: {
    selected: {
      get () {
        return this.$store.state.salesOrder.selected
      },
      set (value) {
        this.$store.commit(SALESORDER_SELECT, value)
      }
    },
    cold_warm_selected: {
      get () {
        return this.$store.state.user.settings.cold_warm
      },
      set (value) {
        this.$store.commit(USER_COLDWARM, value)
      }
    },
    ...mapState({
      salesOrders: state => state.salesOrder.orders
    }),
    ...mapGetters([
      SALESLINES_GET
    ]),
    mapsLink () {
      if (this.selected) {
        if (this.selected.latitude && this.selected.longitude) {
          return 'https://www.google.com/maps/search/?api=1&query=' + this.selected.latitude + ',' + this.selected.longitude
        } else {
          return 'https://www.google.com/maps/search/?api=1&query=' + escape(this.selected.address)
        }
      }
    },
    additionalSalesline () {
      return {
        article: '000000',
        cold_warm: null,
        enabled: true,
        qty_done: 0,
        qty_to_do: 0,
        unity: 'h',
        sales_order_id: this.selected ? this.selected.id : null,
        text_lines: [
          {
            article: '',
            name: 'Sonstige Arbeiten'
          }
        ]
      }
    },
    searchResults () {
      if (this.search.results.length) {
        return this.search.results
      } else {
        return this.salesOrders
      }
    }
  },
  mounted () {
    this.$store.dispatch(SALESORDER_INDEX).then(() => {
      if (this.$store.state.salesOrder.selected) {
        this.$store.commit(SALESORDER_SELECT, this.$store.state.salesOrder.selected.id)
      } else if (this.$route.params.id) {
        this.$store.commit(SALESORDER_SELECT, this.$route.params.id)
      }
    }
    )
    this.$store.dispatch(TIMEENTRY_INDEX)
  },
  watch: {
    'search.query' (val) {
      this.$search(val, this.salesOrders, { keys: ['name'] }).then(result => {
        this.search.results = result
      })
    }
  },
  methods: {
    selectSalesOrder (salesOrder) {
      this.$store.commit(SALESORDER_SELECT, salesOrder.id)
      this.close()
    },
    close () {
      this.search.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SalesOrder/Index.vue